// CSV parsing utility functions
export const readFileAsText = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = (e) => reject(e);
    reader.readAsText(file);
  });
};

export const parseCSV = (csvText) => {
  const lines = csvText.split('\n').filter((line) => line.trim());
  if (lines.length < 2) {
    throw new Error('CSV file must contain at least a header row and one data row');
  }

  // Auto-detect delimiter (comma or semicolon)
  const firstLine = lines[0];
  const delimiter = firstLine.includes(';') ? ';' : ',';

  const headers = firstLine.split(delimiter).map((h) => h.trim());
  const rows = lines.slice(1).map((line) => {
    const values = line.split(delimiter).map((v) => v.trim());
    const row = {};

    headers.forEach((header, index) => {
      row[header] = values[index] || '';
    });

    return row;
  });

  return { headers, rows };
};

export const validateUserRow = (row) => {
  // Basic client-side validation - comprehensive validation will be done on the backend
  const errors = [];

  if (!row.name || !row.name.trim()) {
    errors.push('Name is required');
  }

  if (!row.email || !row.email.trim()) {
    errors.push('Email is required');
  }

  if (!row.role || !row.role.trim()) {
    errors.push('Role is required');
  }

  if (row.fullTimeEmployment && row.fullTimeEmployment.trim()) {
    const fte = parseFloat(row.fullTimeEmployment);
    if (Number.isNaN(fte)) {
      errors.push('FTE must be a valid number');
    } else if (fte < 0 || fte > 1) {
      errors.push('FTE must be between 0 and 1');
    }
  }

  if (row.modality && row.modality.trim()) {
    const validModalities = ['bone_densitometry', 'ct', 'fluoroscopy', 'mammography', 'mri', 'nuclear_medicine', 'us', 'xray'];

    if (!validModalities.includes(row.modality.toLowerCase())) {
      errors.push(`Invalid modality: ${row.modality}. Valid modalities are: ${validModalities.join(', ')}`);
    }
  }

  return {
    errors,
    isValid: errors.length === 0,
  };
};
